import { Box, IconButton, Stack, Typography, alertClasses } from "@mui/material";
import MzAlert from "@markaaz/ui/MzAlert";
import I18n from "i18next";
import MzButton from "@markaaz/ui/MzButton";
import MzIcon from "mz/MzIcon";
import NewLookupForm from "./NewLookupForm";
import MarkaazMatchFound from "./MarkaazMatchFound";
import DownloadReport from "./DownloadReport";
import DownloadReportConfirm from "./DownloadReportConfirm";
const sx = {
  header: {
    color: "darkBlue.c100",
    gap: "10px",
    display: "grid",
    marginBottom: "40px",
    maxWidth: "740px",
    marginTop: "80px"
  },
  alert: {
    width: "740px",
    backgroundColor: "negative.c100",
    margin: "80px 0px",
    padding: "24px 32px",
    [`.${alertClasses.icon}`]: {
      alignItems: "center"
    }
  },
  line: {
    padding: "4px"
  }
};

export default function LookupMain({
  isPartnerChanged,
  contractTermsdata,
  bizMatchData,
  markaazConfidenceScore,
  userType,
  retryData,
  loading,
  accessDeniedAlert,
  lookupData,
  matchFoundTooltipData,
  businessMatchError,
  matchFoundRef,
  matchErrorRef,
  countryCode,
  downloadOpen,
  downloadConfirmOpen,
  onAlertClose,
  onBusinessLookupSubmit,
  downloadInProgress,
  onResetClick,
  onDownloadOpen,
  onDownloadClose,
  onDownloadConfirmClose,
  onRetry,
  onCopyClick,
  onDownload,
  onEditThreshold
}) {
  return (
    <>
      <Typography variant="h4" color="darkBlue.c100">
        {I18n.t("BusinessLookup.businessLookup")}
      </Typography>
      <NewLookupForm
        isPartnerChanged={isPartnerChanged}
        onSubmit={onBusinessLookupSubmit}
        country={countryCode}
        loading={loading}
        userType={userType}
        onResetClick={onResetClick}
        showNameMatchingField={contractTermsdata?.officerNameMatchingEnabled}
        showAdvancedMatch={contractTermsdata?.advancedMatchingEnabled}
        markaazConfidenceScore={markaazConfidenceScore}
        onEditThreshold={onEditThreshold}
      />
      {businessMatchError && (
        <Box ref={matchErrorRef}>
          <MzAlert variant="filled" severity="error" sx={sx.alert} onClose={onAlertClose}>
            {accessDeniedAlert ? (
              <Box>
                <Typography variant="h6" sx={sx.line}>
                  {I18n.t("BusinessLookup.errorHeader")}
                </Typography>
                <Typography variant="body2" sx={sx.line}>
                  You are not currently contracted for this service. To change contract terms, contact your Account
                  Manager
                </Typography>
              </Box>
            ) : (
              <Box>
                <Typography variant="h6" sx={sx.line}>
                  {I18n.t("BusinessLookup.errorHeader")}
                </Typography>
                <Typography variant="body2" sx={sx.line}>
                  Match Confidence Score: {bizMatchData?.markaazMatchConfidenceScore}
                </Typography>
                <Typography variant="body2" sx={sx.line}>
                  Message: {bizMatchData?.message}
                </Typography>
                <Typography variant="body2" sx={{ padding: "4px 0px 0px 4px" }}>
                  Message Id: {bizMatchData?.messageId}
                </Typography>
                <Stack direction="row" alignItems="center">
                  <Typography variant="body2" sx={{ padding: "0px 0px 0px 4px" }}>
                    Trace Id: {bizMatchData?.traceId}
                  </Typography>
                  <IconButton onClick={() => navigator.clipboard.writeText(bizMatchData?.traceId)}>
                    <MzIcon name="CopyIcon" />
                  </IconButton>
                </Stack>
              </Box>
            )}
          </MzAlert>
        </Box>
      )}
      {lookupData && (
        <>
          <Box sx={sx.header}>
            <Typography variant="body1B" fontWeight="600">
              {I18n.t("BusinessLookup.businessDataResponses")}
            </Typography>
            <Typography variant="body2">{I18n.t("BusinessLookup.businessDataDesc1")}</Typography>
            <Typography variant="body2">{I18n.t("BusinessLookup.businessDataDesc2")}</Typography>
          </Box>
          {lookupData.map((item, index) => {
            return (
              <Box key={index} ref={index === 0 ? matchFoundRef : null}>
                <MarkaazMatchFound
                  key={index}
                  index={index}
                  contractTermsdata={contractTermsdata}
                  retryData={retryData}
                  matchFoundTooltipData={matchFoundTooltipData}
                  overviewData={item.overview}
                  firmographicsData={item.firmographic}
                  healthData={item.health}
                  complianceData={item.compliance}
                  hierarchyData={item.hierarchy}
                  diversityData={item.diversity}
                  nameMatchingData={item.nameMatching}
                  downloadOpen={downloadOpen}
                  downloadConfirmOpen={downloadConfirmOpen}
                  downloadInProgress={downloadInProgress}
                  onDownloadOpen={onDownloadOpen}
                  onDownloadClose={onDownloadClose}
                  onDownloadConfirmClose={onDownloadConfirmClose}
                  onRetry={onRetry}
                  onCopyClick={onCopyClick}
                  onDownload={onDownload}
                />
              </Box>
            );
          })}
        </>
      )}

      {lookupData && (
        <Box marginTop="40px">
          <DownloadReport
            open={downloadOpen}
            inProgress={downloadInProgress}
            onClose={onDownloadClose}
            onDownload={onDownload}
          />
          <DownloadReportConfirm open={downloadConfirmOpen} onClose={onDownloadConfirmClose} />
          <MzButton variant="contained" size="large" sx={sx.downloadBtn} onClick={onDownloadOpen}>
            Download Report
          </MzButton>
        </Box>
      )}
    </>
  );
}
